<template>
  <div class="box">
    <div class="tab-list">
      <van-tabs v-model="active" line-width="16px" @disabled="onClickDisabled">
        <van-tab title="球员统计">
          <statistics :is-me="active === 0"/>
        </van-tab>
        <van-tab title="比赛事件">
          <events :is-me="active === 1"/>
        </van-tab>
        <van-tab title="点球大战">
          <penalty :is-me="active === 2"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab, Toast } from 'vant'
import Vue from 'vue'
Vue.use(Tabs).use(Tab).use(Toast)
import Events from './components/Events.vue'
import Statistics from './components/Statistics.vue'
import Penalty from './components/penalty.vue'
export default {
  components: {
    Events,
    Statistics,
    Penalty
  },
  data() {
    return {
      active: 1
    };
  },
  mounted() {
  const active = this.$route.query.active
    if (active === '1') {
      this.active = 1
    }
  },
  methods: {
    onClickDisabled() {
      Toast('敬请期待～')
    }
  },
};
</script>

<style scoped lang="scss">
.box{
  min-height: 100vh;
  background: #F6F6F8;
  padding-top: 50px;
  box-sizing: border-box;
  // border-top: 12px solid #fff;
  ::v-deep .van-tabs__wrap{
    border-bottom: 1px solid #F3F3F3;
  }
  ::v-deep .van-tabs__wrap{
    position: fixed;
    width: 100%;
    top: 0;
  }
  .tab-list{
    ::v-deep .van-tabs__nav--line{
      padding: 0 41px;
    }
    ::v-deep .van-tab__text--ellipsis{
      font-size: 16px;
    }
    ::v-deep .van-tabs__line {
      bottom: 1px !important;
    }
  }
}
</style>
